var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"flex":"1 0","display":"flex","flex-flow":"column"}},[_c('div',{staticStyle:{"display":"flex","flex":"1 0","position":"relative"},attrs:{"id":"container"}})])
}]

export { render, staticRenderFns }